import React from 'react';
import { connect } from 'react-redux';
import { compose } from '@beef/utils';
import { StatelessSearchInput, Text } from '@beef/ui-kit';
import classNames from 'classnames/bind';
import { getAddress } from "../../../../../../../../store/common/actions/getAddress";
import { setIsAddressErrorStatus, setSelectedAddress, setStatus } from "../../../../../store/slice";
import { getOrderTariffInlineTexts, selectDropdownOptions, selectFiasAddress, selectInputDebounce, selectInputError, selectInputPlaceholder, selectIsAddressInputErrorStatus, selectLabelInputText, shouldShowSuggestionInputText } from "../../../../../store/selectors";
import { checkConnectionAndTariffsInPopup } from "../../../../../store/actions/checkConnectionAndTariffsInPopup";
import { useAddressInput } from "./hooks/useAddressInput";
import styles from "./styles.pcss";
var cx = classNames.bind(styles);
export var _AddressInput = function _AddressInput(_ref) {
  var suggestionInputText = _ref.orderTariffInlineTexts.suggestionInputText,
    onSearch = _ref.onSearch,
    onSelect = _ref.onSelect,
    options = _ref.options,
    placeholder = _ref.placeholder,
    isError = _ref.isError,
    errorText = _ref.errorText,
    handleErrorStatus = _ref.handleErrorStatus,
    defaultValue = _ref.defaultValue,
    checkConnection = _ref.checkConnection,
    isSuggestionInputText = _ref.isSuggestionInputText,
    labelInputText = _ref.labelInputText,
    setConnectionStatus = _ref.setConnectionStatus,
    debounce = _ref.debounce;
  var _useAddressInput = useAddressInput({
      onSelect: onSelect,
      isError: isError,
      errorText: errorText,
      handleErrorStatus: handleErrorStatus,
      initValue: defaultValue,
      // @ts-expect-error типизировать позже
      checkConnection: checkConnection,
      setConnectionStatus: setConnectionStatus
    }),
    inputRef = _useAddressInput.inputRef,
    handleChange = _useAddressInput.handleChange,
    handleSelect = _useAddressInput.handleSelect,
    addressInputValue = _useAddressInput.addressInputValue,
    errorMessage = _useAddressInput.errorMessage,
    handleFocus = _useAddressInput.handleFocus;
  return /*#__PURE__*/React.createElement("div", {
    className: cx('addressInput'),
    "data-t-id": "components-AddressInput"
  }, /*#__PURE__*/React.createElement(Text, {
    className: cx('labelAddressText'),
    color: "grey60",
    size: "size5-r-s"
  }, labelInputText), /*#__PURE__*/React.createElement(StatelessSearchInput, {
    debounceInterval: debounce || 700,
    errorMessage: errorMessage,
    inputRef: inputRef
    // @ts-expect-error передача null для удаления дефолтной иконки поиска в инпуте
    ,
    leftAside: null,
    onChange: handleChange,
    onFocus: handleFocus
    // @ts-expect-error fixme later
    ,
    onSearch: onSearch,
    onSelect: handleSelect,
    options: options,
    placeholder: placeholder,
    value: addressInputValue
  }), isSuggestionInputText && /*#__PURE__*/React.createElement("div", {
    className: cx('suggestion')
  }, /*#__PURE__*/React.createElement(Text, {
    size: "size5-r-s",
    tagType: "div"
  }, suggestionInputText)));
};
var mapStateToProps = function mapStateToProps(state) {
  return {
    placeholder: selectInputPlaceholder(state),
    labelInputText: selectLabelInputText(state),
    options: selectDropdownOptions(state),
    isError: selectIsAddressInputErrorStatus(state),
    errorText: selectInputError(state),
    defaultValue: selectFiasAddress(state),
    orderTariffInlineTexts: getOrderTariffInlineTexts(state),
    isSuggestionInputText: shouldShowSuggestionInputText(state),
    debounce: selectInputDebounce(state)
  };
};
var mapDispatchToProps = {
  onSearch: getAddress,
  onSelect: setSelectedAddress,
  handleErrorStatus: setIsAddressErrorStatus,
  checkConnection: checkConnectionAndTariffsInPopup,
  setConnectionStatus: setStatus
};
var connector = connect(mapStateToProps, mapDispatchToProps);
export var AddressInput = compose(connector)(_AddressInput);